import styled from 'libs/styled';

import { type WordpressHeading } from 'libs/wordpress/types/contentSystem/elements';
import { type CssColorKey } from 'config/branding/colors';
import { type CssVariable } from 'config/branding/types';
import transformTextColor from 'libs/wordpress/utils/transformTextColor';

import Column from '@sportson/core-web/App/layouts/Column';
import AccordionFAQ from 'components/productPage/accordions/AccordionFAQ';
import Text from 'components/Text';
import Wysiwyg from 'libs/wordpress/components/Wysiwyg';

const Wrapper = styled(Column)`
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid var(--color-neutrals-200);

    > div:not(:last-child) {
        border-bottom: 1px solid var(--color-neutrals-200);
    }
`;

export interface FAQProps {
    heading?: WordpressHeading;
    questions: {
        question: string;
        answer: string;
    }[];
    textColor?: CssVariable<CssColorKey>;
}

export const FAQ = ({ heading, questions, textColor }: FAQProps) => {
    const headingTextColor = heading?.textColor && transformTextColor(heading?.textColor);

    return (
        <>
            {heading?.text && (
                <Wysiwyg
                    data={heading.text || ''}
                    TextComponent={(props) => (
                        <Text
                            textAlign="left"
                            as={heading.type === 'default' ? 'h3' : heading.type}
                            color={headingTextColor || textColor}
                            typography={['Content/24_130_0_450', null, null, 'Content/40_120_0_500']}
                            {...props}
                        />
                    )}
                />
            )}

            <Wrapper>
                {questions?.map(({ question, answer }) => (
                    <AccordionFAQ key={question} label={question}>
                        <Column gap="24px" padding="0px 24px 24px">
                            <Wysiwyg
                                data={answer}
                                TextComponent={(props) => (
                                    <Text
                                        typography="Content/16_150_0_350"
                                        color="var(--text-color-default)"
                                        {...props}
                                    />
                                )}
                            />
                        </Column>
                    </AccordionFAQ>
                ))}
            </Wrapper>
        </>
    );
};
